:root {
  --bg: #0a0a0b;
  --card: #141416;
  --border: #26262a;
  --text: #ededf0;
  --muted: #8a8a94;
  --green: #30d158;
  --amber: #ffd60a;
  --red: #ff453a;
  --blue: #0a84ff;
  --radius: 10px;
  --ease: cubic-bezier(0.22, 1, 0.36, 1);
  font-family: Inter, system-ui, -apple-system, "Segoe UI", sans-serif;
  -webkit-font-smoothing: antialiased;
}

* { box-sizing: border-box; }

html, body, #root {
  margin: 0; padding: 0; min-height: 100%;
  background: var(--bg); color: var(--text);
}
body { font-size: 14px; line-height: 1.45; }

.app { max-width: 860px; margin: 0 auto; padding: 24px 18px 80px; }
.center { display: grid; place-items: center; min-height: 60vh; color: var(--muted); flex-direction: column; gap: 12px; }

.masthead { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.wordmark { font-size: 18px; font-weight: 650; letter-spacing: -0.02em; }

.tabs { display: flex; gap: 4px; background: var(--card); border: 1px solid var(--border); border-radius: 9px; padding: 3px; }
.tabs button {
  background: transparent; border: 0; color: var(--muted); padding: 6px 14px;
  border-radius: 7px; font-size: 13px; font-weight: 550; cursor: pointer; font-family: inherit;
}
.tabs button.active { background: #232328; color: var(--text); }

.banner { background: rgba(255,69,58,.1); border: 1px solid rgba(255,69,58,.3); color: #ff8f88; border-radius: 8px; padding: 9px 13px; font-size: 13px; margin-bottom: 16px; }

/* month nav */
.month-nav { display: flex; align-items: center; justify-content: center; gap: 18px; margin-bottom: 18px; }
.month-nav button {
  background: var(--card); border: 1px solid var(--border); color: var(--text);
  width: 34px; height: 34px; border-radius: 8px; font-size: 16px; cursor: pointer;
}
.month-nav button:hover { background: #1e1e22; }
.month-label { font-weight: 620; font-size: 15px; min-width: 110px; text-align: center; }

/* ready to assign */
.to-budget {
  background: linear-gradient(135deg, #1c1c20, #16161a);
  border: 1px solid var(--border); border-radius: var(--radius);
  padding: 18px 22px; margin-bottom: 22px;
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;
}
.to-budget .label { font-size: 11px; text-transform: uppercase; letter-spacing: .07em; color: var(--muted); margin-bottom: 3px; }
.to-budget .amount { font-size: 32px; font-weight: 680; letter-spacing: -0.03em; font-variant-numeric: tabular-nums; }
.to-budget .amount.zero { color: var(--green); }
.to-budget .amount.neg { color: var(--red); }
.income-note { color: var(--muted); font-size: 13px; }
.income-note strong { color: var(--text); font-weight: 600; }

/* budget table */
.budget-table { border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; background: var(--card); }
.brow {
  display: grid; grid-template-columns: 1fr 110px 110px 110px;
  align-items: center; padding: 9px 14px; gap: 10px;
  border-bottom: 1px solid #1d1d21;
}
.brow:last-child { border-bottom: 0; }
.bhead {
  font-size: 11px; text-transform: uppercase; letter-spacing: .06em; color: var(--muted);
  background: #101012; font-weight: 600; padding: 8px 14px;
}
.group-row { background: #101013; font-size: 11px; text-transform: uppercase; letter-spacing: .06em; color: var(--muted); font-weight: 600; padding: 7px 14px; }
.catname { font-weight: 520; }
.num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.muted { color: var(--muted); }
.small { font-size: 12px; }
.neg { color: var(--red) !important; }
.flag { color: var(--amber); }

.assigned-cell { cursor: pointer; border-radius: 6px; padding: 2px 6px; margin: -2px -6px; }
.assigned-cell:hover { background: #232328; }
.assigned-cell input {
  width: 90px; text-align: right; background: #0a0a0b; border: 1px solid var(--blue);
  color: var(--text); border-radius: 6px; padding: 3px 6px; font: inherit; font-variant-numeric: tabular-nums;
}

.row-actions { margin-top: 14px; display: flex; gap: 8px; }
.ghost {
  background: transparent; border: 1px solid var(--border); color: var(--text);
  border-radius: 8px; padding: 7px 14px; font-size: 13px; cursor: pointer; font-family: inherit;
}
.ghost:hover { background: #1e1e22; }

/* accounts */
.section-head { display: flex; align-items: center; justify-content: space-between; margin: 26px 0 10px; }
.section-head h2 { font-size: 15px; margin: 0; }
.acct-row, .txn-row {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  background: var(--card); border: 1px solid var(--border); border-radius: 9px;
  padding: 11px 14px; margin-bottom: 7px;
}
.txn-row { grid-template-columns: auto 1fr auto auto; display: grid; }
.txn-payee { font-weight: 530; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* modals */
.modal-bg {
  position: fixed; inset: 0; background: rgba(0,0,0,.6); backdrop-filter: blur(2px);
  display: grid; place-items: center; z-index: 10; padding: 20px;
}
.modal {
  background: #17171a; border: 1px solid #2c2c32; border-radius: 14px;
  padding: 22px; width: 100%; max-width: 380px;
  display: flex; flex-direction: column; gap: 12px;
}
.modal h3 { margin: 0 0 4px; font-size: 16px; }
.modal label { display: flex; flex-direction: column; gap: 5px; font-size: 12px; color: var(--muted); }
.modal input, .modal select {
  background: #0f0f11; border: 1px solid #2c2c32; color: var(--text);
  border-radius: 8px; padding: 9px 11px; font: inherit; font-size: 14px; color-scheme: dark;
}
.modal input:focus, .modal select:focus { outline: none; border-color: var(--blue); }
.split { display: flex; gap: 10px; align-items: end; }
.grow { flex: 1; }
.dir { flex-direction: row !important; align-items: center; gap: 7px !important; }
.modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 6px; }

.fund-all {
  background: var(--blue); color: #fff; border: 0; border-radius: 8px;
  padding: 9px 16px; font-size: 14px; font-weight: 560; cursor: pointer; font-family: inherit;
}
.fund-all:disabled { opacity: .35; cursor: not-allowed; }
.fund-all:hover:not(:disabled) { filter: brightness(1.1); }
